module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-ajax-285.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vue-ajax.md
// module id = 729
// module chunks = 220